
import router from "@/router";
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import FAQS from "@/views/FAQS.vue";
import { useRoute } from "vue-router";
export default {
  name: "Menu",
  components: {
    FAQS,
  },
  setup() {
    const store = useStore();
    const mostrarConfiguracion = ref(false);
    const route = useRoute();

    const GotoTransmission = () => {
      router.push({ name: "Transmission" });
    };
    const GoToPlans = () => {
      router.push({ name: "Plans" });
    };
    const GoToStatePlan = () => {
      router.push({ name: "PlanControl" });
    };
    const GoToEmployerContact = () => {
      router.push({ name: "EmployerContact" });
    };
    const GoToConfiguration = () => {
      router.push({ name: "Configuration" });
    };
    const GoToFaqs = () => {
      router.push({ name: "FAQS" });
    };
    const GoToQualificationDelcop = () => {
      router.push({ name: "QualificationDelcop" });
    };

    function GetFeatureFlag() {
      const data = {
        token: localStorage.getItem("Tokensin"),
        featureFlagName: "PBI-260477",
      };
      store
        .dispatch("GetStatusFeatureFlag", data)
        .then((response) => {
          mostrarConfiguracion.value = response.data;
        })
        .catch((err) => {
          console.error(err);
        });
    }

    function GetKeyVaultSecrets() {
      let parametrosConsulta = {
        token: localStorage.getItem("Tokensin"),
        secret1: "PBI278945",
      };
      store
        .dispatch("GetKeyVaultSecrets", parametrosConsulta)
        .then((response) => {
          if (response.request.status == 200) {
            const mostrarHabilitacion = response.data[0].value === 'true' ? true : false;
            if(mostrarHabilitacion) {
              GetValidarHabilitacionDelcop();
            } else {
              store.dispatch('mostrarMenuHabilitacionAction', mostrarHabilitacion);
            }
          }
        })
        .catch((error) => {
          console.log(error.request.response);
        });
    }

    function GetValidarHabilitacionDelcop() {
      let paramsEmpleador = {
          Tipoidentificacion: localStorage.getItem('TipoIdentificacion'),
          Identificacion: localStorage.getItem('Identificacion'),  
          token: localStorage.getItem('Tokensin')              
      }

      store.dispatch('GetValidarHabilitacionDelcop', paramsEmpleador).then(data=>{
        const habilitadoDelcop = data.data;
        store.dispatch('mostrarMenuHabilitacionAction', !habilitadoDelcop);
      }).catch(error=>{
          console.log("Ocurrio un error al consultar el estado del empleador.");
      });                           
    }

    onMounted(() => {
      GetFeatureFlag();
      GetKeyVaultSecrets()
      GetValidarHabilitacionDelcop()
    });

    return {
      GotoTransmission,
      GoToPlans,
      GoToStatePlan,
      GoToEmployerContact,
      GoToConfiguration,
      mostrarConfiguracion,
      GoToFaqs,
      GoToQualificationDelcop,
      store
    };
  },
};
